import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const breakePoints = {
    desktop: '1279px',
    sDesktop: '1187px',
    tablet: '859px',
};

export const Tariff = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    height: 100%;

    @media (max-width: ${breakePoints.sDesktop}) {
        max-width: 480px;
    }
`;

export const TariffHead = styled.div`
    padding: 35px 8%;
    min-height: 150px;
    width: 100%;
    color: ${COLORS.white};
    background-color: ${COLORS.blue};

    @media (max-width: ${breakePoints.desktop}) {
        padding: 35px 6.5%;
    }
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const TariffTitle = styled.h3`
    ${FONTS.H2};
`;

export const TariffCost = styled.div`
    margin: 0 6px 0 auto;
    ${FONTS.H2};

    @media (max-width: ${breakePoints.desktop}) {
        margin: 0 4px 0 auto;
    }
`;

export const Measure = styled.div`
    display: flex;
    margin-bottom: 4px;
    ${FONTS.S};

    @media (max-width: ${breakePoints.desktop}) {
        ${FONTS.XS};
    }
`;

export const TariffAbout = styled.div`
    margin-top: 12px;
    white-space: pre-wrap;

    @media (max-width: ${breakePoints.tablet}) {
      white-space: normal;
    }
`;

export const TariffDescription = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 40px 8%;
    border: 1px solid ${COLORS.lightGrey};

    @media (max-width: ${breakePoints.desktop}) {
        padding: 40px 6.5%;
    }
`;

const getGradient = (count) => {
    let res = '';
    for (let i = 0; i < 10; i += 1) {
        const color = (i < count) ? COLORS.blue : COLORS.grey;
        res = res.concat(`, ${color} ${i * 10}%, ${color} ${i * 10 + 9}%, ${COLORS.white} ${i * 10 + 9}%, ${COLORS.white} ${(i + 1) * 10}%`);
    }
    return 'linear-gradient(to right' + res + ')';
};

export const TariffCount = styled.div`
    position: relative;
    display: flex;
    align-items: flex-end;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 40px;
    padding-bottom: 10px;
    min-height: 52px;
    line-height: 1.3;

    & > i {
        margin-right: 3px;
        ${FONTS.H2};
    }

    & > b {
        margin: 0 2px;
    }

    & > span {
        display: flex;
        margin-left: 6px;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        width: 100%;
        height: 2px;
        background-image: ${({ count }) => getGradient(count)};
    }
`;

export const TariffContain = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    margin-bottom: 20px;
`;

export const TariffIcon = styled.img`
    margin-right: 20px;
    ${({ isActive }) => isActive
        ? ''
        : `
            filter: grayscale(100%);
            opacity: 0.5;
        `
    }
`;

export const Question = styled.div`
    width: 16px;
    height: 16px;
    cursor: pointer;

    &::before {
        content: '\\e66c';
        font-family: 'icomoon';
        color: ${COLORS.grey};
        font-size: 18px;
        line-height: 0.9;
    }

    &:hover {
        &::before {
            color: ${COLORS.yellow};
        }
    }
`;

export const TextWrap = styled.div`
    flex: 1 1 auto;
    margin-right: 5px;
`;

export const TariffText = styled.div`
    width: 100%;
    margin-bottom: 0;
    ${FONTS.S};
`;

export const ActiveText = styled(TariffText)`
    color: ${({ isActive }) => isActive ? COLORS.black : COLORS.grey};
`;

export const TooltipText = styled(TariffText)`
    display: block;
    text-align: center;
    width: 230px;
    ${FONTS.XS};

    & > a {
        cursor: pointer;
    }
`;

export const DivicesWrap = styled.div`
    margin-bottom: 35px;
`;

export const DivicesLabel = styled.h4`
    width: 100%;
    margin-bottom: 25px;
`;

export const DivicesList = styled.ul`
    list-style: none;
    padding: 0;
`;

export const DivicesItem = styled.li`
    display: flex;
    align-items: center;
    margin-bottom: 5px;
`;

export const Check = styled.div`
    margin-right: 5px;
    width: 18px;
    height: 18px;
    ${p => p.isActive
        ? `
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAALBAMAAABSacpvAAAAJ1BMVEUAAAAAeuUAeuMAeOcAeOQAeuUAdeQAeuYAeeQAeeIAeOMAeN8AeuXARYMkAAAADHRSTlMA34AgYO8wr3BQQCAYWBc3AAAAM0lEQVQI12MAA/MECM0s4wBhGB6CCSgAydUwAdEEiACDTxhUBctRkABYCKqFgbOBAQUAALjtCKxMkRIiAAAAAElFTkSuQmCC);
            background-repeat: no-repeat;
            background-position: center left;
        `
        : `
            height: 2px;
            width: 15px;
            margin-right: 8px;
            background-color: ${COLORS.grey};
        `
    }
`;

export const DivicesText = styled(TariffText)`
    border-bottom: 1px dashed ${COLORS.black};
    opacity: ${p => p.isActive ? '1' : '0.5'};
`;

export const Button = styled(BaseButton)`
    margin-top: auto;
`;
